import {baseEnvironmentConfigs, EnvironmentName} from "./baseEnvironmentConfigs";

const baseUrl = 'https://pre4-ccp-pcc.cbsa-asfc.cloud-nuage.canada.ca';
const carmWebServices = '/carmwebservices/v2/carm';
export const siteBaseUrl = 'https://pre4-ccp-pcc.cbsa-asfc.cloud-nuage.canada.ca';

export const environment = {
  production: true,
  devLogin: false,
  showTestAccounts: false,
  showHeartBeat: false,
  allowMultipleLogin: false,
  testAccountsType: 'DEV',
  showEnvironmentHeader: true,
  name: EnvironmentName.Ry4,
  debugMode: false,
  analytics: true,
  monerisTest: true,
  showNodeId: true,
  loginConfig: baseEnvironmentConfigs.loginSetting(
    'https://apps-cbsa-asfc.fjgc-gccf.gc.ca/LCS/?l=eng&t=https://apps-wo.cbsa-asfc.gc.ca/gckeyprpccportal',
    'https://apps-cbsa-asfc.fjgc-gccf.gc.ca/LCS/?l=fra&t=https://apps-wo.cbsa-asfc.gc.ca/gckeyprpccportal',
    'https://apps-cbsa-asfc.fjgc-gccf.gc.ca/LCS/?l=eng&t=https://apps-wo.cbsa-asfc.gc.ca/securekeyprpccportal',
    'https://apps-cbsa-asfc.fjgc-gccf.gc.ca/LCS/?l=fra&t=https://apps-wo.cbsa-asfc.gc.ca/securekeyprpccportal',
  ),
  deploymentWarningSettings: baseEnvironmentConfigs.deploymentWarningSettings(60, 5, 1),
  userIdleSettings: baseEnvironmentConfigs.userIdleSettingsConfigs(60, 1140, 900, 2400),
  storeConfig: baseEnvironmentConfigs.storeConfigs(baseUrl, carmWebServices, 'carm', 'secret'),
  httpConfig: baseEnvironmentConfigs.httpConfig(4, 2000, 360000, 360000),
  business: baseEnvironmentConfigs.urls(baseUrl, carmWebServices, 'https://esqa.moneris.com/HPPDP/index.php'),
  apiEndpointUrls: {
    getcad: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/declaration-srv-ces2-read/commercialAccountingDeclarations',
    postcad: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/declaration-srv-ces2-submit/commercialAccountingDeclarations',
    release: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/declaration-srv-ces2/releaseStatuses',
    bond: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/bond-srv-ces2/eBonds',
    tariff: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/tariff-srv-ces2/tariffClassifications',
    exciseTaxes: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/tariff-srv-ces2/exciseTaxes',
    customsDuties: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/tariff-srv-ces2/customsDuties',
    exciseDuties: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/tariff-srv-ces2/exciseDuties',
    gstCodes: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/tariff-srv-ces2/gstCodes',
    exciseTaxCodes: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/tariff-srv-ces2/exciseTaxCodes',
    batch: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/tariff-srv-ces2/$batch',
    duty: 'https://pre0-ccapi-ipacc.cbsa-asfc.cloud-nuage.canada.ca/v1/duty-srv-ces2/dutyTaxCalculator'
  },
  baseApiUrls: baseUrl + carmWebServices
};
